// @flow

import * as React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

import ButtonAction from './ButtonAction';

import type { CommonActionProps } from './types.actions';
import { DesktopView, MobileView } from '../../config/mediaQuery';


class ClearFiltersAction extends React.Component<Props & CommonActionProps, State> {
  static defaultProps = {
    size: 'xsmall',
    disabled: false,
  };

  render() {
    const { size, disabled, clearInternalFilters } = this.props;

    return (
      <>
        <DesktopView>
          <ButtonAction
            onClick={clearInternalFilters}
            bsSize={size}
            disabled={disabled}
          >
            <Glyphicon glyph="filter" /> Clear Filters
          </ButtonAction>
        </DesktopView>
        <MobileView>
          <button
            className='filter-clear-menu-button'
            onClick={clearInternalFilters}
            disabled={disabled}
          >
            <img
              src='assets/filter-red.svg'
              alt='display menu icon'
            />
            Clear
          </button>
        </MobileView>
      </>
    );
  }
}

export default ClearFiltersAction;
